import { LocaleState } from '@merchant-portal/merchant-portal-base'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DatePicker, { registerLocale } from 'react-datepicker'
import { midas } from '@resurs/midas'
import Moment from 'moment'
import da from 'date-fns/locale/da'
import fi from 'date-fns/locale/fi'
import nb from 'date-fns/locale/nb'
import sv from 'date-fns/locale/sv'
import { selectDateFormat } from '../../util/dateUtils'
import { getText } from '../TextLabels'

import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './react-datepicker-override.css'

registerLocale('sv', sv)
registerLocale('da', da)
registerLocale('fi', fi)
registerLocale('nb', nb)

class Datepicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      valid: true,
      validationMessage: '',
    }

    this.onChangeRaw = this.onChangeRaw.bind(this)
    this.handleChangeDate = this.handleChangeDate.bind(this)
  }

  handleChangeDate(valid, name) {
    if (this.props.handleChangeDate) {
      this.props.handleChangeDate(valid, name)
    }
  }

  // Only called when input field is changed
  onChangeRaw(minDate, maxDate, event) {
    let inputDate = event.target.value

    // Do not allow input field to be cleared
    if (!inputDate && !this.props.allowEmptyDate) {
      const target = event.target
      target.value = Moment(this.props.selected).toDate()
      inputDate = Moment(this.props.selected).format('YYYY-MM-DD')
    }

    const validFormat = /^\d{4}-\d{2}-\d{2}$/
    const valid =
      inputDate &&
      inputDate.match(validFormat) &&
      Moment(inputDate, 'YYYY-MM-DD').isValid() &&
      Moment(inputDate).isBefore(maxDate) &&
      Moment(inputDate).isAfter(minDate)

    this.setValidationMessage(valid, inputDate, minDate, maxDate)
    this.handleChangeDate(valid, this.props.name)
    this.setState({ valid })
  }

  onChange = e => {
    this.setState({ valid: true })
    this.handleChangeDate(true, this.props.name)
    this.props.onChange(e)
  }

  setValidationMessage = (valid, inputDate, minDate, maxDate) => {
    let validationMessage = ''
    const dateFormat = selectDateFormat(this.context.language)
    const formattedMinDate = Moment(minDate).format(dateFormat)
    const formattedMaxDate = Moment(maxDate).format(dateFormat)

    const {
      validationMessageKeyNotInRange,
      validationMessageKeyInvalidFormat,
    } = this.props

    if (!valid) {
      if (
        Moment(inputDate).isAfter(maxDate) ||
        Moment(inputDate).isBefore(minDate)
      ) {
        validationMessage = getText(validationMessageKeyNotInRange, {
          formattedMinDate,
          formattedMaxDate,
        })
      } else {
        validationMessage = getText(validationMessageKeyInvalidFormat)
      }
    }
    this.setState({ validationMessage })
  }

  render() {
    const wrapperClassNames = [
      this.props.direction === 'row' && midas.formGroup,
      !this.state.valid && midas.hasDanger,
      this.state.valid && midas.hasSuccess,
    ]
      .filter(val => val)
      .join(' ')

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: this.props.direction,
        }}
      >
        <div className={midas.formGroup}>
          {this.props.label && (
            <label className={midas.formLabel} htmlFor={this.props.name}>
              {this.props.label}
            </label>
          )}
          <DatePicker
            name={this.props.name}
            selected={this.props.selected?.toDate() || null}
            onChange={this.onChange}
            minDate={this.props.minDate?.toDate()}
            maxDate={this.props.maxDate?.toDate()}
            dateFormat={this.props.dateFormat}
            disabled={this.props.disabled}
            locale={this.context.language}
            className={midas.formInput}
            onChangeRaw={event =>
              this.onChangeRaw(this.props.minDate, this.props.maxDate, event)
            }
            toggleCalendarOnIconClick
            showIcon={!!this.props.icon}
            icon={this.props.icon}
          />
        </div>
        <div>
          {!this.state.valid && (
            <div
              className={wrapperClassNames}
              style={
                this.props.direction === 'row'
                  ? {
                      paddingLeft: '5px',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      maxWidth: '250px',
                    }
                  : {}
              }
            >
              <span className={midas.formInputHint}>
                {this.state.validationMessage}
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }
}

Datepicker.contextType = LocaleState

Datepicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  handleChangeDate: PropTypes.func,
  dateFormat: PropTypes.string,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  validationMessageKeyNotInRange: PropTypes.string,
  validationMessageKeyInvalidFormat: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  icon: PropTypes.node,
  allowEmptyDate: PropTypes.bool,
}

Datepicker.defaultProps = {
  label: null,
  disabled: false,
  selected: null,
  dateFormat: 'yyyy-MM-dd',
  minDate: Moment.unix(1),
  maxDate: undefined,
  handleChangeDate: null,
  validationMessageKeyNotInRange: 'default.dateNotInRange',
  validationMessageKeyInvalidFormat: 'default.dateInvalidFormat',
  direction: 'row',
  icon: null,
  allowEmptyDate: false,
}
export default Datepicker
